(() => {
	const debugMode = 1,
		testId = "GLX-028",
		logInfo = testId + " -->",
		variation = 1,
		forceShow = false;

	try {
		// Avoid code to run multiple times
		if (!document.documentElement.classList.contains(`${testId}_var_${variation}`)) {
			document.documentElement.classList.add(`${testId}_var_${variation}`);
			document.documentElement.classList.add(`${testId}_var`);

			// Tampermonkey has a specific window scope. This will make sure you access the correct website's "window" object.
			let _window = window;
			if (typeof unsafeWindow !== "undefined") _window = unsafeWindow;

			_window._conv_q = _window._conv_q || [];

			const isTouchDevice = () => {
				try {
					return _window.matchMedia("(pointer: coarse)").matches;
				} catch (err) {
					if (debugMode) console.error(logInfo, err.message);
				}
			};

			function waitForElements(cssSelector, multi, callback, maxCalls) {
				try {
					var elementsCached; // [Configurable] Times out after 6 seconds

					var interval = setInterval(function () {
						try {
							if (multi) {
								elementsCached = document.querySelectorAll(cssSelector);

								// Checks if element 'cssSelector' exists
								if (elementsCached.length) {
									clearInterval(interval);
									callback(elementsCached);
								}
							} else {
								elementsCached = document.querySelector(cssSelector);

								// Checks if element 'cssSelector' exists
								if (elementsCached) {
									clearInterval(interval);
									callback(elementsCached);
								}
							}

							// After trying to find the element for 6 seconds, it stops

							if (typeof maxCalls === "number" && --maxCalls < 0) {
								clearInterval(interval);
							}
						} catch (err) {
							if (debugMode) console.error(logInfo, err.message);
						}
					}, 20);
				} catch (err) {
					if (debugMode) console.error(logInfo, err.message);
				}
			}

			// Send Convert event
			const sendConvertEvent = (number, label = "") => {
				try {
					_conv_q.push(["triggerConversion", number]);

					if (debugMode) console.log(logInfo, "Convert event sent:", number, label);
				} catch (err) {
					if (debugMode) console.error(logInfo, err.message);
				}
			};

			let modalShown = false;

			// Watch for exit intent from the user and show the popup
			const observeExitIntent = (bodyElement) => {
				try {
					var device = isTouchDevice() ? "mobile" : "desktop";

					if (device !== "mobile") {
						bodyElement.onmouseout = (evt) => {
							try {
								var showIntent = !evt.toElement && !evt.relatedTarget && evt.clientY < 10;

								if (showIntent && !modalShown) {
									document.documentElement.classList.remove(`${testId}-hide`);
									_window.localStorage.setItem(`${testId}-modal`, "seen");
									modalShown = true;
									sendConvertEvent("100480041", "[GLX-028] Seen Popup");
								}
							} catch (err) {
								if (debugMode) console.error(logInfo, err.message);
							}
						};
					} else {
						// Set up mobile exit intent
						var lastScrollPosition = _window.pageYOffset || document.documentElement.scrollTop,
							scrolledDown = false,
							scrollUps = 0,
							timer,
							observeScrolling = () => {
								try {
									var newScrollPosition = _window.pageYOffset || document.documentElement.scrollTop;

									// User scrolled, restart the 8 second timer
									restartTimer();

									// Record upward movements
									if (newScrollPosition < lastScrollPosition) {
										scrollUps++;
									}

									// Show the modal when the user makes 50 individual upward movements
									if (scrollUps > 150) {
										showModal();
									}

									// Store the new scroll position
									lastScrollPosition = newScrollPosition;
								} catch (err) {
									if (debugMode) console.error(logInfo, err.message);
								}
							},
							// Start an 8 second timer
							restartTimer = () => {
								try {
									clearTimeout(timer);

									timer = setTimeout(() => {
										try {
											showModal();
										} catch (err) {
											if (debugMode) console.error(logInfo, err.message);
										}
									}, 8000);
								} catch (err) {
									if (debugMode) console.error(logInfo, err.message);
								}
							},
							// Show the modal and stop observing user interactions
							showModal = () => {
								try {
									clearTimeout(timer);

									if (!modalShown) {
										// Stop observing user behaviour
										_window.ontouchstart = null;
										_window.removeEventListener("scroll", observeScrolling, true);

										document.documentElement.classList.remove(`${testId}-hide`);
										_window.localStorage.setItem(`${testId}-modal`, "seen");
										modalShown = true;
										sendConvertEvent("100480041", "[GLX-028] Seen Popup");
									}
								} catch (err) {
									if (debugMode) console.error(logInfo, err.message);
								}
							};

						// Start the timer on page load
						restartTimer();

						// Restart the 8 second timer when the user touches the screen
						_window.ontouchstart = restartTimer;

						// Monitor the scrolling behaviour
						_window.addEventListener("scroll", observeScrolling, true);
					}

					if (debugMode) console.log("Waiting for exit intent");
				} catch (err) {
					if (debugMode) console.error(logInfo, err.message);
				}
			};

			if (forceShow || _window.localStorage.getItem(`${testId}-modal`) !== "seen") {
				waitForElements("cart-drawer line-item img", false, (firstProductImage) => {
					try {
						document.documentElement.classList.add(`${testId}-hide`);

						// Get first product image from cart
						const productImageSrc = firstProductImage.src;

						document.body.insertAdjacentHTML(
							"beforeEnd",
							`
								<div class="${testId}-overlay"></div>
								<div class="${testId}-modal">
									<svg class="${testId}-modal-close" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M1 15L15 1" stroke="black"/>
										<path d="M1 1L15 15" stroke="black"/>
									</svg>

									<div class="${testId}-modal-image"></div>

									<div class="${testId}-content">
										<h5>Don't forget, you have items in your cart!</h5>
										<div class="${testId}-product">
											<img src="${productImageSrc}" alt="Product Image">
											<div class="${testId}-product-info">
												<p class="${testId}-viewers">129 people are viewing this product</p>
											</div>
										</div>
										<a href="/cart" class="${testId}-checkout-btn">Checkout Now</a>
										<a href="/pages/stores" class="${testId}-store-link">FIND A STORE NEAR YOU</a>
									</div>
								</div>
							`
						);

						const overlay = document.querySelector(`.${testId}-overlay`);
						const modal = document.querySelector(`.${testId}-modal`);
						const modalClose = modal.querySelector("svg");
						const cartButton = modal.querySelector(`.${testId}-checkout-btn`);
						const findStoreLink = modal.querySelector(`.${testId}-store-link`);

						overlay.addEventListener("click", () => {
							try {
								document.documentElement.classList.add(`${testId}-hide`);
								sendConvertEvent("100480040", "[GLX-028] Close Popup Clicks");
							} catch (err) {
								if (debugMode) console.error(logInfo, err.message);
							}
						});

						modalClose.addEventListener("click", () => {
							try {
								document.documentElement.classList.add(`${testId}-hide`);
								sendConvertEvent("100480040", "[GLX-028] Close Popup Clicks");
							} catch (err) {
								if (debugMode) console.error(logInfo, err.message);
							}
						});

						cartButton.addEventListener("click", () => {
							try {
								sendConvertEvent("100480039", "[GLX-028] Checkout Now CTA Clicks");
							} catch (err) {
								if (debugMode) console.error(logInfo, err.message);
							}
						});

						findStoreLink.addEventListener("click", () => {
							try {
								sendConvertEvent("100480042", "[GLX-028] Find Store Click Link Clicks");
							} catch (err) {
								if (debugMode) console.error(logInfo, err.message);
							}
						});

						observeExitIntent(document.body);
					} catch (err) {
						if (debugMode) console.error(logInfo, err.message);
					}
				});
			}
		}
	} catch (err) {
		if (debugMode) console.error(logInfo, err.message);
	}
})();